<template>
  <section class="text-input" :class="{'text-input--ac': ac}" >
    <p v-if="label" class="text-input__label">{{ label }}</p>
    <input
      v-bind="$attrs"
      class="text-input__input"
      :class="{ 'ac-input': ac }"
      type="text"
      :placeholder="placeholder"
      :maxlength="maxLength"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event)"
    >
    <p v-if="error" class="text-input__message">{{ error }}</p>
  </section>
</template>

<script>
  import {mapState} from "vuex"

  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      maxLength: {
        type: Number
      },
      error: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapState({
        ac: state => state.ac
      })
    }
  };
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/mixins';

  .text-input__label {
    display: block;
    margin: 0;
    padding: 0;
    color: #808080;
    font-family: timsans_regular;
    font-size: 0.8125rem;
    line-height: normal;
    text-transform: uppercase;
  }

  .text-input--ac .text-input__label {
    color: #FFFFFF;
  }

  .text-input--ac .text-input__input {
    @include placeholdercolor(#FFFFFF);
    color: #FFFFFF;
  }

  .text-input__message {
    display: block;
    color: red;
    margin: 12px 0;
    padding: 0;
    font-size: 0.75em;
    font-family: "timsans_regular";
  }

  .text-input--ac .text-input__message {
    color: #FFFF00;
  }
</style>
